import React, { useState } from "react";
import { BarekamIcon } from "../../icon/barekam-icon";
import { InputProps } from "@mui/material";
import Message from "../../message";
import { MessageSections } from "../../message/message";
import { AttachmentIcons } from "../../icon/variants";
import { BarekamFileInputContainer } from "../styled";
import BarekamText from "../../text";
import { FileUploader } from "react-drag-drop-files";
import { useAppSelector } from "../../../../redux/store";

const fileTypes = ["JPG", "PNG", "PDF", "DOC"];

const BarekamFileInput = ({ onChange, disabled, messageSection }: BarekamFileInputProps) => {
    const { matchesPc } = useAppSelector(state => state.deviceReducer);

    const [file, setFile] = useState(null);
    const handleChange = (file: any) => {
        setFile(file);
        onChange(file)
    };

    return (
        <FileUploader handleChange={handleChange}
            name="file"
            types={fileTypes}
            maxSize={15}>
            <BarekamFileInputContainer>
                <BarekamIcon variant={AttachmentIcons.upload} size={{ width: '1.5rem', height: '1.5rem' }} />

                <BarekamText variant={'m'} align={'center'} width={'max-content'}>
                    <Message messageKey={'attach_file'} sectionId={messageSection ? messageSection : MessageSections.ORDERS} />
                </BarekamText>

                {matchesPc
                    ? <BarekamText variant={'m'} align={'center'} width={'max-content'} opaque>
                        <Message messageKey={'or_drag_and_drop'}
                            sectionId={messageSection ? messageSection : MessageSections.ORDERS} />
                    </BarekamText>
                    : ''
                }
            </BarekamFileInputContainer>
        </FileUploader>
    );
};

export default BarekamFileInput;

interface BarekamFileInputProps extends InputProps {
    onChange: any;
    disabled?: boolean;
    messageSection?: MessageSections;
}
